import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'digi-radio',
  templateUrl: './input-radio.component.html',
  styleUrl: './input-radio.component.scss'
})
export class InputRadioComponent {
  @Input() label: string = ''; // Nhãn cho nhóm radio
  @Input() control: FormControl = new FormControl(); // FormControl để liên kết với Reactive Forms
  @Input() options: { label: string, value: any }[] = []; // Mảng các lựa chọn
  @Input() disabled: boolean = false; // Trạng thái disabled của radio
}
